var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ComponentCollapse",
        {
          staticClass: "collect_list",
          attrs: { activeNamesList: _vm.recordLists },
          on: { change: _vm.change },
        },
        _vm._l(_vm.numList, function (item) {
          return _c(
            "ul",
            {
              key: item.question_style,
              staticClass: "collapse-cell",
              attrs: { slot: "collapseContent" },
              slot: "collapseContent",
            },
            [
              _c("li", { staticClass: "item" }, [
                _vm._v(_vm._s(item.style_name.slice(0, -2))),
              ]),
              _c("li", { staticClass: "item" }, [_vm._v(_vm._s(item.num))]),
              _c(
                "li",
                { staticClass: "item" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "uni-link-btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.jump(item)
                        },
                      },
                    },
                    [_vm._v("重做错题")]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _vm.recordLists.length == 0
        ? _c("ComponentEmpty", { attrs: { title: "暂无错题记录", tips: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }